import React from 'react';
import PropTypes from 'prop-types';
import RowCell from './MedicineCell';
import * as MedicineIcons from '../Icons/Medicines';
import medicineShape from '../../shapes/medicine';

export const getMedicineKey = m => `${m.variantName}-${m.vmpId}`;
const getMedicineName = m => m.brandName || m.drugName || m.name;
const getMedicineDescription = m => m.brandDesc || m.prodDesc;
const getMedicineIcon = m => {
  if (typeof(m) !=='string' && !m.form) {
    return <MedicineIcons.DefaultMedicine />;
  }
  const f = typeof(m) ==='string' ? m.toLowerCase() : m.form.toLowerCase();
  if (f.includes('bag')) return <MedicineIcons.Bag />;
  if (f.includes('capsule')) return <MedicineIcons.Capsule />;
  if (f.includes('eyedrops')) return <MedicineIcons.EyeDrops />;
  if (f.includes('oralsuspension')) return <MedicineIcons.OralSuspension />;
  if (f.includes('patch')) return <MedicineIcons.Patch />;
  if (f.includes('powder')) return <MedicineIcons.Powder />;
  if (f.includes('solutionforinjection')) { return <MedicineIcons.SolutionForInjection />; }
  if (f.includes('spray')) return <MedicineIcons.Spray />;
  if (f.includes('strip')) return <MedicineIcons.Strip />;
  if (f.includes('tablet')) return <MedicineIcons.Tablet />;
  if (f.includes('vial')) return <MedicineIcons.Vial />;
  return <MedicineIcons.DefaultMedicine />;
};

const MedicineRowCell = ({ medicine, icon, noIcon, orderStatus, ...props }) => (
  <RowCell
    {...props}
    key={getMedicineKey(medicine)}
    title={getMedicineName(medicine)}
    subtitle={getMedicineDescription(medicine)}
    icon={noIcon ? null : (icon || getMedicineIcon(medicine))}
    isND={medicine.nd && !['prescription_returned', 'cancelled'].includes(orderStatus)}
    isMCS={medicine.isMCS && medicine.status !=='delivered' && !['prescription_returned', 'cancelled', 'delivered'].includes(orderStatus)}
    medicineStatus={medicine.status}
  />
);

MedicineRowCell.propTypes = {
  medicine: medicineShape.isRequired,
  destructiveActionText: PropTypes.string,
  icon: PropTypes.element,
  accessory: PropTypes.element,
  selected: PropTypes.bool,
  inputType: PropTypes.oneOf(['radio', 'checkbox', null]),
  inputName: PropTypes.string,
  inputValue: PropTypes.string,
  onInputChange: PropTypes.func,
  onDestructiveAction: PropTypes.func,
  destructiveFormAction: PropTypes.string,
  titleWrapper: PropTypes.bool,
  noIcon: PropTypes.bool,
  orderStatus: PropTypes.string,
};

MedicineRowCell.defaultProps = {
  ...RowCell.defaultProps,
};

export const MedicineFormRowCell = ({ formType, key, ...props }) => (
  <RowCell
    {...props}
    key={key}
    title={formType}
    icon={getMedicineIcon(formType)}
  />
);

MedicineFormRowCell.propTypes = {
  ...MedicineRowCell.propTypes,
  formType: PropTypes.string,
  key: PropTypes.number,
};

MedicineFormRowCell.defaultProps = {
  ...RowCell.defaultProps,
  formType: '',
  key: null,
};

export default MedicineRowCell;
